import { BaseEntity } from "./base-entity";
import { Address } from "../shared/address";
import { MatterType } from "./model/matter-type";
import {
  DpBooleanValueTypes,
  NoYes_DefaultNoType,
  PROVINCE_CODES,
} from "../shared/constants";
import {
  MatterStatusType,
  MatterStatusTypesValue,
} from "./model/matter-status";
import { MatterEvent } from "./matter-event";
import { MatterWorkItem } from "../common/matter-work-item";
import { ContactSummary } from "./contact-summary";
import { MatterInvoice } from "./matter-invoice";

export class MatterMobileSectionTypes {
  public static readonly OUTSTANDING: MatterMobileSectionType = "OUTSTANDING";
  public static readonly CONTACT_US: MatterMobileSectionType = "CONTACT_US";
  public static readonly TASKS: MatterMobileSectionType = "TASKS";
  public static readonly APPOINTMENT: MatterMobileSectionType = "APPOINTMENT";
  public static readonly INITIATE_MESSAGE: MatterMobileSectionType =
    "INITIATE_MESSAGE";
  public static readonly CORRESPONDENCE: MatterMobileSectionType =
    "CORRESPONDENCE";
}

export type MatterMobileSectionType =
  | "OUTSTANDING"
  | "CONTACT_US"
  | "TASKS"
  | "APPOINTMENT"
  | "CORRESPONDENCE"
  | "INITIATE_MESSAGE";

export class MatterInfo extends BaseEntity {
  id: number;
  matterType: MatterType;
  matterTypeName: string;
  matterTypeReserved: boolean;
  lawFirm: string;
  propertyAddress: Address;
  lawFirmAddress: Address;
  projectName: string;
  matterDescription: string;
  legalDescription: string;
  closingDate: string;
  occupancyDate: string;
  vendorSolicitor: ContactSummary;
  lawClerk: ContactSummary;
  provinceCode: string;
  logoFirmFileId: number;
  lawFirmFullAddress: string;
  projectSharingInformation: string;
  closed: NoYes_DefaultNoType;
  matterStatus: MatterStatusType;
  matterAddressOrDescription: string;
  linkId: number;
  appointments: MatterEvent[];
  userMatterWorkItems: MatterWorkItem[];
  matterInvoices: MatterInvoice[];

  constructor(matterInfo?: MatterInfo) {
    super(matterInfo);

    if (matterInfo) {
      if (matterInfo.propertyAddress) {
        this.propertyAddress = new Address(matterInfo.propertyAddress);
      }
      if (matterInfo.lawFirmAddress) {
        this.lawFirmAddress = new Address(matterInfo.lawFirmAddress);
      }
      this.userMatterWorkItems = [];
      if (
        matterInfo &&
        matterInfo.userMatterWorkItems &&
        matterInfo.userMatterWorkItems.length
      ) {
        matterInfo.userMatterWorkItems.forEach((workItem) =>
          this.userMatterWorkItems.push(new MatterWorkItem(workItem))
        );
      }
      this.appointments = [];
      if (
        matterInfo &&
        matterInfo.appointments &&
        matterInfo.appointments.length
      ) {
        matterInfo.appointments.forEach((appointment) =>
          this.appointments.push(new MatterEvent(appointment))
        );
      }

      // if(matterInfo.matterInvoices){
      //     for(const matterInvoice in matterInfo.matterInvoices){
      //         this.matterInvoices.push(new MatterInvoice(matterInvoice))
      //     }
      // }
    }
  }

  isProvinceABorMBorSK(): boolean {
    return (
      this.provinceCode === PROVINCE_CODES.ALBERTA ||
      this.provinceCode === PROVINCE_CODES.MANITOBA ||
      this.provinceCode === PROVINCE_CODES.SASKATCHEWAN
    );
  }

  isCustomMatter(): boolean {
    return this.matterType == "CUSTOM";
  }

  get fileStatus(): string {
    if (this.closed === DpBooleanValueTypes.YES) {
      return "Closed";
    } else if (this.matterStatus === MatterStatusTypesValue.INACTIVE) {
      return "Inactive";
    } else {
      return "In Progress";
    }
  }
  completedTaskItems(): number {
    return this.userMatterWorkItems
      ? this.userMatterWorkItems.filter((item) => item.status == "COMPLETED")
          .length
      : 0;
  }

  get matterTypeDetail(): string {
    return this.isCustomMatter() ? this.matterDescription : this.matterType;
  }

  get matterTypeText(): string {
    return this.matterTypeDetail
      ? this.matterTypeDetail.toLowerCase().charAt(0).toUpperCase() +
          this.matterTypeDetail.toLowerCase().slice(1)
      : "";
  }
}
